import { render } from "./DataPolicyView.vue?vue&type=template&id=167925b8"
import script from "./DataPolicyView.vue?vue&type=script&lang=js"
export * from "./DataPolicyView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__